let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5a167")).then(() => parcelRequire('jUuBC'));